import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

const ComparisonWidget = ({ config = {} }) => {
  const title = config.title || 'Period Comparison';
  const metric = config.metric || 'Traffic';
  const currentValue = config.currentValue;
  const previousValue = config.previousValue;
  const currentLabel = config.currentLabel || 'This Month';
  const previousLabel = config.previousLabel || 'Last Month';
  const format = config.format || 'number';

  // Both periods must come from a real source; otherwise show nothing.
  if (typeof currentValue !== 'number' || typeof previousValue !== 'number') {
    return (
      <div className="h-full w-full flex flex-col items-center justify-center text-center p-4">
        <div className="text-3xl font-bold text-gray-300 leading-none">&mdash;</div>
        <div className="text-xs text-gray-400 mt-2">No data source connected</div>
      </div>
    );
  }


  const change = currentValue - previousValue;
  const changePercent = previousValue > 0 ? ((change / previousValue) * 100).toFixed(1) : 0;
  const isPositive = change > 0;

  const formatVal = (v) => {
    if (format === 'currency') return '$' + v.toLocaleString();
    if (format === 'percentage') return v + '%';
    return v.toLocaleString();
  };

  return (
    <div className="h-full flex flex-col bg-white p-4">
      <h3 className="text-sm font-semibold text-gray-700 mb-3" style={{ color: config.titleColor || '#374151' }}>
        {title}
      </h3>
      <div className="flex-1 flex items-center justify-around">
        <div className="text-center">
          <p className="text-xs text-gray-400 mb-1">{previousLabel}</p>
          <p className="text-xl font-bold text-gray-600">{formatVal(previousValue)}</p>
        </div>
        <div className="flex flex-col items-center px-4">
          <div className={`flex items-center gap-1 text-sm font-semibold ${isPositive ? 'text-green-500' : change < 0 ? 'text-red-500' : 'text-gray-400'}`}>
            {isPositive ? <TrendingUp className="w-4 h-4" /> : change < 0 ? <TrendingDown className="w-4 h-4" /> : <Minus className="w-4 h-4" />}
            {changePercent}%
          </div>
          <p className="text-xs text-gray-400 mt-1">{isPositive ? '+' : ''}{formatVal(change)}</p>
        </div>
        <div className="text-center">
          <p className="text-xs text-gray-400 mb-1">{currentLabel}</p>
          <p className="text-xl font-bold" style={{ color: config.color || '#3B82F6' }}>{formatVal(currentValue)}</p>
        </div>
      </div>
    </div>
  );
};

export default ComparisonWidget;
